import { render, staticRenderFns } from "./ItsCustomsApplyFee.vue?vue&type=template&id=47eccf2c&scoped=true&"
import script from "./ItsCustomsApplyFee.vue?vue&type=script&lang=js&"
export * from "./ItsCustomsApplyFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47eccf2c",
  null
  
)

export default component.exports